// extracted by mini-css-extract-plugin
export default {"offerLocation":"XdrJkvYOVO"};